export default __webpack_public_path__ + "static/logo-4f205864d8e488d9ba9cde5c8b5ae5fe.png";